import {Quiz as template, Summary as summaryTemplate } from 'templates/components/quiz';
import {QuizQuestionView} from './QuizQuestionView';


export {Quiz} from './Quiz';
export {QuizQuestion} from './QuizQuestion';
export {QuizQuestionView} from './QuizQuestionView';
export {Summary} from './Summary';


export const quizRegistrations = {
    'Quiz': { template },
    'QuizQuestion': QuizQuestionView,
    'Summary': { template: summaryTemplate }
};